module.exports = __webpack_public_path__ + "img/facts-example.ba2d684.png";